import { createSelector } from 'reselect';
import { KEY, MaintenanceState } from './types';
import { GlobalState } from 'store/types';

const getMaintenanceState = (state: GlobalState) => state[KEY] as MaintenanceState;

const selectKioskHardwareIdOutOfStock = createSelector(getMaintenanceState, (state) => state.kioskHardwareIdOutOfStock);

const selectLastPrintedOrderDetails = createSelector(getMaintenanceState, (state) => state.lastPrintedOrderDetails);

export const selectors = {
  selectKioskHardwareIdOutOfStock,
  selectLastPrintedOrderDetails
};
